export default {
  sinceJobStart: 'Since job start',
  sinceFirstInBand: 'Since first value in band',
};
